import { Component, OnInit } from '@angular/core';
import { FlashProductGroup } from '../../../../models/inModels/Flash';
import { FlashService } from '../../../../services/flash/flash.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/primeng';
import { StorageService } from '../../../../services/system/storage.service';

@Component({
  selector: 'app-edit-flash-group',
  templateUrl: './edit-flash-group.component.html'
})
export class EditFlashGroupComponent implements OnInit {
  	id;
	model: FlashProductGroup;
	loading = false;
	error: Message[];
	uploading = false;
	books;
  	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private service: FlashService,
		public storageService: StorageService,
	) { 
		this.id = this.route.snapshot.paramMap.get('Id');
	}

  ngOnInit() {
    this.getGroup();
  }

  getGroup() {
		this.loading = true;
		this.service.getGroup(this.id).then(
			result => {
				this.model = new FlashProductGroup(result);
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

  goBack(): void {
		this.router.navigate(['/flash/groups']);
  }

  handleImage(event): void {
	var result = this.storageService.handleSuccess(event);
	this.model.productGroupImageId = result.PublicId;
	this.loading = false;
	}
	
	save() {
		this.loading = true;
		this.service.updateGroup(this.model).then(
		result => {
			this.loading = false;
			this.model = new FlashProductGroup(result);
			this.error = [];
			this.error.push({ severity: 'success', summary: 'Success', detail: "Event saved" });
		},
		error => {
			this.loading = false;
			this.error = [];
			this.error.push({ severity: 'error', summary: 'Error', detail: error });
		});
  }
  
  handleError(event): void {
		this.loading = false;
		this.error = [];
	}

}



// WEBPACK FOOTER //
// ./src/app/components/flash/groups/group-edit/edit-flash-group.component.ts